import { useEffect, useState } from "react";
import mascotNoInternet from "../Assets/icons/okkali_mascot_nointernet.png";

const OfflinePage = () => {
  const [dots, setDots] = useState("");
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 600);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setPulse((p) => !p), 2000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50/40 select-none">
      <div className="flex flex-col items-center gap-6 sm:gap-8 px-6 text-center max-w-lg w-full">
        <div className={`transition-transform duration-700 ${pulse ? "scale-105" : "scale-100"}`}>
          <img
            src={mascotNoInternet}
            alt="İnternet bağlantısı yok"
            className="w-44 h-44 sm:w-56 sm:h-56 md:w-64 md:h-64 object-contain drop-shadow-2xl mx-auto"
            draggable={false}
          />
        </div>

        <div className="space-y-3">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-800">
            İnternet Bağlantısı Yok
          </h1>
          <p className="text-slate-500 text-base sm:text-lg leading-relaxed max-w-md mx-auto">
            İnternet bağlantınız kesilmiş görünüyor.
            <br className="hidden sm:block" />
            Lütfen ağ bağlantınızı kontrol edin.
          </p>
        </div>

        <div className="flex items-center gap-3 bg-slate-100/80 backdrop-blur-sm px-6 py-3.5 rounded-2xl border border-slate-200/60 shadow-sm">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" />
          </span>
          <span className="text-sm sm:text-base text-slate-600 font-medium">
            Bağlantı bekleniyor{dots}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfflinePage;
